/**
 * Persistent storage (currently localStorage) for app sidebar state.
 */
export const AppSidebarStorage = {
  /** Whether the sidebar is open. Defaults to true. */
  getOpen(): boolean {
    const value = localStorage.getItem("AppSidebar.open");
    return value !== "false"; // defaults to true
  },

  /** The width (in pixels) of the sidebar. */
  getWidth(): number | null {
    const value = localStorage.getItem("AppSidebar.width_in_pixels");

    if (value === null) {
      return null;
    }

    const width = Number(value);
    return Number.isFinite(width) ? width : null;
  },

  /** Set whether the sidebar is open. */
  setOpen(value: boolean): void {
    localStorage.setItem("AppSidebar.open", String(value));
  },

  /** Set the width of the sidebar in pixels. */
  setWidth(value: number): void {
    localStorage.setItem("AppSidebar.width_in_pixels", value.toString());
  },
};
